import { ResponsivePie } from "@nivo/pie";

import { Typo } from "../../../Typo";
import { PieData, TranslatedContent } from "../../types";

export const ChartSectionEntryMini = ({
  data,
  translations,
}: {
  data: PieData[];
  translations: TranslatedContent;
}) => {
  const total = data.reduce((sum, item) => sum + item.value, 0);
  return (
    <div className="flex flex-row items-center justify-between">
      <div className="flex flex-col gap-1">
        <Typo type="labelSM" textColor="text-text-secondary">
          {translations.accountReportTab.graphs.totalAccounts}
        </Typo>
        <Typo element="h4" type="headingLG">
          {total}
        </Typo>
      </div>

      <div className="h-[50px] w-[50px]">
        <ResponsivePie
          id="mini-pie-chart"
          data={data}
          innerRadius={0.7}
          padAngle={2}
          cornerRadius={1}
          enableArcLinkLabels={false}
          enableArcLabels={false}
          colors={{ datum: "data.color" }}
        />
      </div>
    </div>
  );
};
